import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../theme';

const { colors, spacing, breakpoints, sizes } = redesignTheme;

export const useIAChatPanelStyles = makeStyles(() => ({
  backdrop: {
    position: 'fixed',
    inset: 0,
    backgroundColor: colors.chatBackdrop,
    zIndex: 1300,
  },
  panel: {
    position: 'fixed',
    top: 'var(--ia-chat-panel-top, 0px)',
    right: 0,
    bottom: 0,
    display: 'flex',
    flexDirection: 'column',
    width: sizes.chatPanelWidth,
    backgroundColor: colors.white,
    zIndex: 1301,
    [`@media (max-width: ${breakpoints.mobile}px)`]: {
      width: '100%',
      maxWidth: '100%',
    },
  },
  body: {
    flex: 1,
    overflowY: 'auto',
    padding: spacing.md,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: colors.white,
  },
  bodyWelcome: {
    justifyContent: 'flex-end',
  },
}));
